// Pricing utilities — keep in sync with backend `effective_unit_price`

export function effectiveUnitPrice(basePrice, tiers, qty) {
  const base = Number(basePrice) || 0;
  if (!Array.isArray(tiers) || tiers.length === 0) return base;
  const valid = tiers
    .filter((t) => Number(t.min_qty) > 0 && Number(t.min_qty) <= qty)
    .sort((a, b) => Number(b.min_qty) - Number(a.min_qty));
  if (!valid.length) return base;
  const p = Number(valid[0].price);
  return Number.isFinite(p) ? p : base;
}

export function bestTierDiscount(product) {
  const base = Number(product?.price) || 0;
  const tiers = product?.tiers || [];
  if (!base || !tiers.length) return 0;
  let bestPct = 0;
  for (const t of tiers) {
    const p = Number(t.price);
    if (!Number.isFinite(p) || p >= base) continue;
    const pct = ((base - p) / base) * 100;
    if (pct > bestPct) bestPct = pct;
  }
  return Math.round(bestPct);
}

export function sortedTiers(tiers) {
  return [...(tiers || [])].sort((a, b) => Number(a.min_qty) - Number(b.min_qty));
}
